import { Box, Chip } from "@mui/material";
import styled from "styled-components";

export const SonhosRealizadosDetails = styled.div`
  width: 100%;

  margin: 100px 0px 40px 0px;
  display: flex;
  justify-content: center;

  padding: 0px 20px;

  .content {
    width: 100%;
    max-width: 1200px;
  }
`;

export const Lista = styled(Box)`
  display: grid;

  grid-template-columns: 1fr 1fr 1fr;

  row-gap: 30px;
  column-gap: 20px;

  @media (max-width: 1000px) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media (max-width: 800px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 550px) {
    grid-template-columns: 1fr;
  }

  .item-list {
    cursor: pointer;
    position: relative;
    flex-basis: 300px;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    background-color: #fff;

    border-radius: 16px;
    transition: all 0.3s;
    user-select: none;

    &:hover {
      transform: translateY(-6px);
    }

    .img-item-list {
      width: 100%;
      height: 350px;
      border-top-left-radius: 16px;
      border-top-right-radius: 16px;
      object-fit: cover;
    }

    @media (max-width: 1200px) {
      flex-basis: 300px;
    }
  }
`;

export const ChipFlutuant = styled(Chip)`
  position: absolute;
  bottom: 50px;
  right: 20px;
`;
